import React from 'react';
import UserModal from './Modal';
import { createCustomerPermissionUpdate } from '../util/CustomerPermissionHelper';
import { useTranslation } from 'react-i18next';

const RemoveCustomerUser = (props) => {
    const { t } = useTranslation(['common']);

    const removeUser = () => {
        const updates = createCustomerPermissionUpdate([props.user], []);
        props.update(updates);
    }

    return (
        <UserModal
            header={t('customerPermissions.removePermission.title', { ns: 'common' })}
            body={t('customerPermissions.removePermission.areYouSure', { ns: 'common', displayName: props.user.displayName })}
            isOpen={props.isOpen}
            toggleModal={() => props.toggleModal()}
            update={removeUser}
            disabled={props.disabled}
            savingState={props.savingState}
            cancel={t('no', { ns: 'common' })}
            confirm={t('yes', { ns: 'common' })}
        />
    )
}

export default RemoveCustomerUser;
